import { ImageField, Item, RichTextField } from '@sitecore-jss/sitecore-jss-nextjs';
import {
  AnchorTargetParams,
  RenderingProps,
  TranslationOptionsParams,
} from 'src/shared/shared.types';

export type S08BlogListingProps = RenderingProps<
  {
    NoResultsText?: RichTextField;
    ScopeSearchToSection?: Item[];
    PlaceholderImage?: ImageField;
  },
  {
    NumberOfSearchResultsPerPage?: string;
  } & TranslationOptionsParams &
    AnchorTargetParams
>;
